import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image } from 'react-native';
import PropTypes from 'prop-types';

import Colors from '../../constants/Colors';
import { Card, Icon, Button } from '../';
import { cardArrow, cardDescription } from "./CardStyles";

const CardTextArrow = (props) => {

    const { onPress, text, textStyle, children, showArrow, headerComponent, containerStyle, arrowColor } = props;
    const HeaderComponent = headerComponent;

    const backColor = containerStyle === undefined ? Colors.cardBackgroundColor : containerStyle.backgroundColor;
    // const arrowColor =  (backColor === 'white' || backColor === '#ffffff' || backColor === '#FFFFFF') ? 'black' : 'white';

    return (
        <TouchableOpacity
            disabled={!showArrow}
            onPress={() => {
                if (onPress === undefined || onPress === null)
                    return;

                onPress();
            }}
        >
            <Card containerStyle={[styles.cardContainer, containerStyle]}>
                <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>

                    <View style={{flexDirection: 'row', alignItems: 'flex-start', minWidth: '80%'}}>
                        {
                            (props.iconSource !== undefined && props.iconSource !== null) &&
                                <Image
                                    source={props.iconSource}
                                    style={[styles.iconStyle, props.iconStyle]}
                                    resizeMode={'contain'}
                                />
                        }

                        <Text style={[styles.textStyle, textStyle]}>
                            {text}
                        </Text>
                    </View>

                    {
                        showArrow === true &&
                            <View style={{width: '15%', alignItems: 'center', justifyContent: 'center'}}>
                                <Icon
                                    iconSource={require('../../img/icons/arrows/thickArrow.png')}
                                    imagePropStyle={{
                                    	height: 22,
                                    	width: 22,
                                    	tintColor: arrowColor,
                                    }}
                                />
                            </View>
                    }

                </View>

                {children}

            </Card>
        </TouchableOpacity>
    )
};

const styles = StyleSheet.create({
    cardContainer: {
        borderWidth: 0,
        backgroundColor: Colors.cardBackgroundColor,
        borderRadius: 8,
    },
    iconStyle: {
        width: 32,
        height: 32,
        marginRight: 8,
        tintColor: 'white'
    },
    textStyle: {
    	fontSize: 18,
		color: 'white',
		fontWeight: 'bold',
		textAlignVertical: 'center',
    },
});

CardTextArrow.propTypes = {
    iconSource: PropTypes.any,
    text: PropTypes.string.isRequired,
    showArrow: PropTypes.bool.isRequired,

    onPress: PropTypes.func,

    containerStyle: PropTypes.any,
    iconStyle: PropTypes.object,
};

export { CardTextArrow };
